export const requestAction = (key) => ({ type: `${key}_REQUEST` });
export const successAction = (key, payload) => ({
  type: `${key}_SUCCESS`,
  payload,
});
export const failureAction = (key, payload) => ({
  type: `${key}_FAILURE`,
  payload,
});
